import React from 'react';
import DocumentRuleDetailSection from '../../../sections/AdminDashboard/Configuration/DocumentRuleDetail';

const DocumentRuleDetail = () => {
  return <DocumentRuleDetailSection />;
};

export default DocumentRuleDetail;
